import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#upload" }),
    /*#__PURE__*/_createTextVNode(" Upload ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Upload files by clicking or drag-and-drop ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIClickToUploadFiles = _resolveComponent("EUIClickToUploadFiles")
  const _component_EUIUserAvatarUpload = _resolveComponent("EUIUserAvatarUpload")
  const _component_EUIPhotoWall = _resolveComponent("EUIPhotoWall")
  const _component_EUICustomFileThumbnail = _resolveComponent("EUICustomFileThumbnail")
  const _component_EUIFileListWithThumbnail = _resolveComponent("EUIFileListWithThumbnail")
  const _component_EUIFileListControl = _resolveComponent("EUIFileListControl")
  const _component_EUIDragToUpload = _resolveComponent("EUIDragToUpload")
  const _component_EUIManualUpload = _resolveComponent("EUIManualUpload")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIClickToUploadFiles),
    _createVNode(_component_EUIUserAvatarUpload),
    _createVNode(_component_EUIPhotoWall),
    _createVNode(_component_EUICustomFileThumbnail),
    _createVNode(_component_EUIFileListWithThumbnail),
    _createVNode(_component_EUIFileListControl),
    _createVNode(_component_EUIDragToUpload),
    _createVNode(_component_EUIManualUpload)
  ], 64))
}